import { createStyles } from '@mantine/core'

import { ChartSizeType } from '../index.types'

type StyleParams = {
  size: ChartSizeType
  backgroundColor: string
}

export default createStyles((theme, { backgroundColor }: StyleParams) => {
  return {
    root: {},
    inner: {
      position: 'relative',
      minHeight: 260,
      '.error-screen': {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        backgroundColor,
      },
      '.chart-screen': {
        position: 'relative',
        zIndex: 0,
      },
    },
    icon: { flexShrink: 0 },
    errorScreenRoot: {
      [theme.fn.smallerThan('sm')]: {
        justifyContent: 'space-evenly',
      },
    },
  }
})
